import { IKImage } from "imagekitio-react";
import React, { useEffect, useState } from "react";

const PriceTag = ({ activePlanProducts , activeChildProduct , setActiveChildProduct}) => {


  useEffect(() => {
    if (activePlanProducts?.length > 1) {
      let newArray = activePlanProducts?.filter(
        (product) => product?.is_best_value === true
      );
      setActiveChildProduct((prev) => newArray?.[0]);
    } else if (activePlanProducts?.length === 1) {
      setActiveChildProduct(activePlanProducts?.[0]);
    } else {
      setActiveChildProduct([]);
    }
  }, [activePlanProducts]);

  return (
    <div className="mt-5 md:mt-12 w-full text-sm md:w-2/3">
      {activePlanProducts?.length > 1 && (
        <div className="mb-4 flex w-full items-center justify-around rounded-xl  bg-gray-200 py-1">
          {activePlanProducts?.map((product, idx) => (
            <div
              className={`mr-1 ml-1 flex w-full cursor-pointer items-center justify-center whitespace-nowrap ${
                product?.products_id === activeChildProduct?.products_id
                  ? "bg-white text-black"
                  : "bg-gray-200 opacity-[26%]"
              } rounded-xl bg-white px-2 py-2`}
              onClick={(e) => setActiveChildProduct(product)}
            >
              <div>{product?.product_tab_heading}</div>
              {product?.is_best_value && (
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src="https://assets.learntube.ai/files/PRICING/Best_Value_1.svg?updatedAt=1681542670952"
                  transformation={[
                    {
                      height: "150",
                      width: "150",
                    },
                  ]}
                  className="ml-1 h-5 w-5"
                />
              )}
            </div>
          ))}
        </div>
      )}
      {activeChildProduct?.cost_details && (
        <div className="flex w-full flex-col items-center justify-center ">
          <div
            className={` mb-1 mt-2 flex flex-col items-center justify-center text-4xl font-bold`}
          >
            <div className="flex flex-row">
              <div className="self-end text-xl font-light">at</div>
              <h1 className="ml-1">
                ₹{activeChildProduct?.cost_details?.final_cost_monthly}
              </h1>
              <h4 className="self-end text-lg font-medium">/Month</h4>
            </div>
            <div className="flex flex-row">
              <h1 className="text-lg font-medium text-red-500 line-through">
                ₹{activeChildProduct?.cost_details?.original_cost_monthly}
              </h1>
              <h4 className="self-end text-lg font-medium text-red-500 line-through">
                /Month
              </h4>
            </div>
          </div>
          <div className="text-sm font-medium">
            Pay: ₹{activeChildProduct?.cost_details?.final_cost_total} total
            (for {activeChildProduct?.product_tab_heading}){" "}
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceTag;
